var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRght(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9294 15.4818L15.371 12.8572L6.82759 12.8746C6.37018 12.8746 6 12.4768 6 11.9852C6 11.4954 6.37018 11.0959 6.82759 11.0959L15.3128 11.0785L12.9294 8.51817C12.607 8.1707 12.607 7.60792 12.9294 7.26054C13.2527 6.91315 13.7772 6.91315 14.1005 7.26054L17.5062 10.9204C17.806 11.1637 18 11.551 18 11.9852C18 12.324 17.8836 12.6314 17.6913 12.8659C17.667 12.9007 17.6404 12.9336 17.6113 12.965L14.1005 16.7395C13.7772 17.0868 13.2527 17.0868 12.9294 16.7395C12.607 16.3921 12.607 15.8293 12.9294 15.4818Z",
    fill: "#9F9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRght);
export default __webpack_public_path__ + "static/media/arrowRght.3bfbdefe78757e1193760b95f0f450dc.svg";
export { ForwardRef as ReactComponent };